var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.704,
    height: 48.256,
    viewBox: "0 0 52.704 48.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "form-logo",
    transform: "translate(-89.613 -200.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(89.613 200.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M155.172,292.473s-7.87.07-10.056-1.874A18.034,18.034,0,0,1,147.1,271L132,275.477,138,292.988l.006.007,0,.005.015.015.012.011.022.021.018.017.03.027.027.023.038.032.035.028.047.036.045.033.056.04.054.037.066.044.063.041.076.047.074.044.088.05.084.047.1.053.094.049.113.056.1.051.128.058.113.051.152.064.115.048c.064.026.133.052.2.077l.161.06c.08.029.161.058.246.087l.147.048.2.065.171.051.207.06.189.051.22.058.205.05.235.056.222.049.25.053.239.047.266.05.256.045.285.047.272.042.305.043.287.038.325.039.3.034.347.035.319.03.372.03.332.025c.133.009.27.017.407.025l.336.019c.149.007.3.013.458.019l.327.013c.2.007.405.011.612.015l.213.005h0q.869.014,1.829,0c10.3-.172,14.077,3.434,9.957,7.382s-11.846,5.338-11.846,5.338h23.863S195.344,293.5,155.172,292.473Z",
    transform: "translate(-131.996 -259.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M238.871,424.286q-.961.016-1.829,0a17.99,17.99,0,0,0,12.453,4.988c.3,0,.6-.008.894-.023C251.065,426.37,247,424.151,238.871,424.286Z",
    transform: "translate(-220.33 -388.749)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M350.67,206.253a18.052,18.052,0,0,1,9.552,26.938l8.364-.146v-32.1Z",
    transform: "translate(-315.881 -200.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M203.824,255.007c2.18,1.948,10.061,1.878,10.061,1.878,9.294.238,15.214,1.2,18.826,2.547a18.057,18.057,0,1,0-28.887-4.424Z",
    transform: "translate(-190.709 -224.266)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M203.824,255.007c2.18,1.948,10.061,1.878,10.061,1.878,9.294.238,15.214,1.2,18.826,2.547a18.057,18.057,0,1,0-28.887-4.424Z",
    transform: "translate(-190.709 -224.266)",
    fill: "#ffc629"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLogo);
export default __webpack_public_path__ + "static/media/form-logo.dd67f254a36f4c0b83756d6c175e0cb0.svg";
export { ForwardRef as ReactComponent };